var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AdminTweet"}},[_c('div',{staticClass:"admin-navbar"},[_c('AdminNewNavbar',{attrs:{"status":_vm.status}})],1),_c('div',{staticClass:"adminTweetPanel"},[_vm._m(0),_c('adminTweetList',{attrs:{"tweets":_vm.tweets},on:{"after-delete-tweet":_vm.handleDeleteTweet}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("推文清單")])])
}]

export { render, staticRenderFns }